<template>
  <div class="frameParent" v-if="classObj">
    <div class="frameParent1">
      <div class="textParent">
        <b class="text"
          >{{
            startDate.toLocaleDateString("default", { month: "long" })
          }}
          Class</b
        >
        <div class="start121524Parent">
          <div class="text">
            Start: {{ startDate.toLocaleDateString() }} <b> | </b> End:
            {{ endDate.toLocaleDateString() }} <b> | </b>
            {{ classObj.students.length }} Enrolled
          </div>
        </div>
      </div>
      <div class="frameParent2">
        <img
          class="frameIcon"
          alt=""
          :src="classObj.activeInstructor.user.image"
        />
        <div class="frameParent3">
          <div class="instructorParent">
            <div class="text">
              Instructor | {{ classObj.curriculum.program.name }}
            </div>
          </div>
          <b class="instructorName"
            >{{ classObj.activeInstructor.user.firstName }}
            {{ classObj.activeInstructor.user.lastName }}</b
          >
        </div>
      </div>
      <div class="backButtonWrapper" @click="goBack">
        <img class="backButtonIcon" alt="" src="/static/img/LeftChevron.svg" />
      </div>
    </div>
    <div class="tableContainer">
      <div class="tableBorderWrapper">
        <div class="tableWrapper">
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th class="blueHeader">Grade</th>
                <th
                  class="orangeHeader"
                  v-for="assignment of classObj.assignments"
                  v-bind:key="assignment.id"
                >
                  {{ assignment.name }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="student of classObj.students" v-bind:key="student.id">
                <td class="greyHeader">
                  {{ student.user.firstName }} {{ student.user.lastName }}
                </td>
                <td class="blueHeader">
                  {{ student.averageGrade.toFixed(1) }}%
                </td>
                <td
                  v-for="assignment of student.studentAssignments"
                  v-bind:key="assignment.id"
                >
                  <span v-if="isNaN(assignment.gradePercentage)" class="noClick"
                    >-</span
                  >
                  <span
                    v-else
                    class="gradePercentage"
                    @click="
                      goToGradedAssignment(
                        assignment.assignmentId,
                        student.user.id,
                      )
                    "
                    :class="!assignment.assignment.graded ? 'notGraded' : ''"
                    >{{ assignment.gradePercentage.toFixed(1) }}%</span
                  >
                </td>
              </tr>
            </tbody>
          </table>
          <div class="fadeRight"></div>
          <div class="fadeLeft"></div>
        </div>
      </div>
    </div>

    <!--    <div class="d-flex" style="width: 100%">
      <div style="width: 30%" class="p-2">
        <div class="card">
          <div class="title purple-title d-flex justify-content-center">
            <img class="pr-2" src="/static/img/Sparkling-white.svg" />
            <b>Suggestions for Class Improvement</b>
          </div>
          <div class="body">
            <div style="margin-bottom: 20px">
              <div class="subheader d-flex justify-content-between">
                <b>Flight Skills</b>
                <div class="d-flex" style="color: #40404080; font-size: 12px">
                  Mark as Done
                  <div class="radio"></div>
                </div>
              </div>
              <div class="paragraph">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec a
                diam lectus. Sed sit amet ipsum mauris. Maecenas congue ligula
                ac quam viverra nec
              </div>
            </div>
            <div style="margin-bottom: 20px">
              <div class="subheader d-flex justify-content-between">
                <b>Flight Skills</b>
                <div class="d-flex" style="color: #40404080; font-size: 12px">
                  Mark as Done
                  <div class="radio"></div>
                </div>
              </div>
              <div class="paragraph">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec a
                diam lectus. Sed sit amet ipsum mauris. Maecenas congue ligula
                ac quam viverra nec
              </div>
            </div>
            <div style="margin-bottom: 20px">
              <div class="subheader d-flex justify-content-between">
                <b>Flight Skills</b>
                <div class="d-flex" style="color: #40404080; font-size: 12px">
                  Mark as Done
                  <div class="radio"></div>
                </div>
              </div>
              <div class="paragraph">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec a
                diam lectus. Sed sit amet ipsum mauris. Maecenas congue ligula
                ac quam viverra nec
              </div>
            </div>
            <div style="margin-bottom: 20px">
              <div class="subheader d-flex justify-content-between">
                <b>Flight Skills</b>
                <div class="d-flex" style="color: #40404080; font-size: 12px">
                  Mark as Done
                  <div class="radio"></div>
                </div>
              </div>
              <div class="paragraph">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec a
                diam lectus. Sed sit amet ipsum mauris. Maecenas congue ligula
                ac quam viverra nec
              </div>
            </div>
            <div style="margin-bottom: 20px">
              <div class="subheader d-flex justify-content-between">
                <b>Flight Skills</b>
                <div class="d-flex" style="color: #40404080; font-size: 12px">
                  Mark as Done
                  <div class="radio"></div>
                </div>
              </div>
              <div class="paragraph">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec a
                diam lectus. Sed sit amet ipsum mauris. Maecenas congue ligula
                ac quam viverra nec
              </div>
            </div>
            <div style="margin-bottom: 20px">
              <div class="subheader d-flex justify-content-between">
                <b>Flight Skills</b>
                <div class="d-flex" style="color: #40404080; font-size: 12px">
                  Mark as Done
                  <div class="radio"></div>
                </div>
              </div>
              <div class="paragraph">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec a
                diam lectus. Sed sit amet ipsum mauris. Maecenas congue ligula
                ac quam viverra nec
              </div>
            </div>
            <div style="margin-bottom: 20px">
              <div class="subheader d-flex justify-content-between">
                <b>Flight Skills</b>
                <div class="d-flex" style="color: #40404080; font-size: 12px">
                  Mark as Done
                  <div class="radio"></div>
                </div>
              </div>
              <div class="paragraph">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec a
                diam lectus. Sed sit amet ipsum mauris. Maecenas congue ligula
                ac quam viverra nec
              </div>
            </div>
          </div>
          <div class="p-3">
            <button style="width: 100%" class="purple-title">
              Chat with Hilo Help
            </button>
          </div>
        </div>
      </div>
      <div style="width: 30%" class="p-2">
        <div class="card">
          <div class="title reddish-title d-flex justify-content-between">
            <div class="d-flex">
              <img class="pr-2" src="/static/img/Calendar.svg" />
              <b>Upcoming Class Events</b>
            </div>
            <b>0/14</b>
          </div>
          <div class="body glow" style="height: 525px !important">
            <div style="margin-bottom: 20px">
              <div class="subheader d-flex justify-content-between">
                <div class="d-flex" style="width: 65%; max-width: 65%">
                  <div class="portion greytext">Mon@0600</div>
                  <div class="portion" style="font-weight: bold">
                    Flight 5 - Climbs Descents
                  </div>
                </div>
                <div
                  class="d-flex"
                  style="color: #40404080; font-size: 12px; white-space: nowrap"
                >
                  Mark as Done
                  <div class="radio"></div>
                </div>
              </div>
              <div class="paragraph">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec a
                diam lectus. Sed sit amet ipsum mauris. Maecenas congue ligula
                ac quam viverra nec
              </div>
            </div>
            <div style="margin-bottom: 20px">
              <div class="subheader d-flex justify-content-between">
                <div class="d-flex" style="width: 65%; max-width: 65%">
                  <div class="portion greytext">Mon@0600</div>
                  <div class="portion" style="font-weight: bold">
                    Flight 5 - Climbs Descents
                  </div>
                </div>
                <div
                  class="d-flex"
                  style="color: #40404080; font-size: 12px; white-space: nowrap"
                >
                  Mark as Done
                  <div class="radio"></div>
                </div>
              </div>
              <div class="paragraph">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec a
                diam lectus. Sed sit amet ipsum mauris. Maecenas congue ligula
                ac quam viverra nec
              </div>
            </div>
            <div style="margin-bottom: 20px">
              <div class="subheader d-flex justify-content-between">
                <div class="d-flex" style="width: 65%; max-width: 65%">
                  <div class="portion greytext">Mon@0600</div>
                  <div class="portion" style="font-weight: bold">
                    Flight 5 - Climbs Descents
                  </div>
                </div>
                <div
                  class="d-flex"
                  style="color: #40404080; font-size: 12px; white-space: nowrap"
                >
                  Mark as Done
                  <div class="radio"></div>
                </div>
              </div>
              <div class="paragraph">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec a
                diam lectus. Sed sit amet ipsum mauris. Maecenas congue ligula
                ac quam viverra nec
              </div>
            </div>
            <div style="margin-bottom: 20px">
              <div class="subheader d-flex justify-content-between">
                <div class="d-flex" style="width: 65%; max-width: 65%">
                  <div class="portion greytext">Mon@0600</div>
                  <div class="portion" style="font-weight: bold">
                    Flight 5 - Climbs Descents
                  </div>
                </div>
                <div
                  class="d-flex"
                  style="color: #40404080; font-size: 12px; white-space: nowrap"
                >
                  Mark as Done
                  <div class="radio"></div>
                </div>
              </div>
              <div class="paragraph">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec a
                diam lectus. Sed sit amet ipsum mauris. Maecenas congue ligula
                ac quam viverra nec
              </div>
            </div>
            <div style="margin-bottom: 20px">
              <div class="subheader d-flex justify-content-between">
                <div class="d-flex" style="width: 65%; max-width: 65%">
                  <div class="portion greytext">Mon@0600</div>
                  <div class="portion" style="font-weight: bold">
                    Flight 5 - Climbs Descents
                  </div>
                </div>
                <div
                  class="d-flex"
                  style="color: #40404080; font-size: 12px; white-space: nowrap"
                >
                  Mark as Done
                  <div class="radio"></div>
                </div>
              </div>
              <div class="paragraph">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec a
                diam lectus. Sed sit amet ipsum mauris. Maecenas congue ligula
                ac quam viverra nec
              </div>
            </div>
            <div style="margin-bottom: 20px">
              <div class="subheader d-flex justify-content-between">
                <div class="d-flex" style="width: 65%; max-width: 65%">
                  <div class="portion greytext">Mon@0600</div>
                  <div class="portion" style="font-weight: bold">
                    Flight 5 - Climbs Descents
                  </div>
                </div>
                <div
                  class="d-flex"
                  style="color: #40404080; font-size: 12px; white-space: nowrap"
                >
                  Mark as Done
                  <div class="radio"></div>
                </div>
              </div>
              <div class="paragraph">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec a
                diam lectus. Sed sit amet ipsum mauris. Maecenas congue ligula
                ac quam viverra nec
              </div>
            </div>
            <div style="margin-bottom: 20px">
              <div class="subheader d-flex justify-content-between">
                <div class="d-flex" style="width: 65%; max-width: 65%">
                  <div class="portion greytext">Mon@0600</div>
                  <div class="portion" style="font-weight: bold">
                    Flight 5 - Climbs Descents
                  </div>
                </div>
                <div
                  class="d-flex"
                  style="color: #40404080; font-size: 12px; white-space: nowrap"
                >
                  Mark as Done
                  <div class="radio"></div>
                </div>
              </div>
              <div class="paragraph">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec a
                diam lectus. Sed sit amet ipsum mauris. Maecenas congue ligula
                ac quam viverra nec
              </div>
            </div>
            <div style="margin-bottom: 20px">
              <div class="subheader d-flex justify-content-between">
                <div class="d-flex" style="width: 65%; max-width: 65%">
                  <div class="portion greytext">Mon@0600</div>
                  <div class="portion" style="font-weight: bold">
                    Flight 5 - Climbs Descents
                  </div>
                </div>
                <div
                  class="d-flex"
                  style="color: #40404080; font-size: 12px; white-space: nowrap"
                >
                  Mark as Done
                  <div class="radio"></div>
                </div>
              </div>
              <div class="paragraph">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec a
                diam lectus. Sed sit amet ipsum mauris. Maecenas congue ligula
                ac quam viverra nec
              </div>
            </div>
            <div style="margin-bottom: 20px">
              <div class="subheader d-flex justify-content-between">
                <div class="d-flex" style="width: 65%; max-width: 65%">
                  <div class="portion greytext">Mon@0600</div>
                  <div class="portion" style="font-weight: bold">
                    Flight 5 - Climbs Descents
                  </div>
                </div>
                <div
                  class="d-flex"
                  style="color: #40404080; font-size: 12px; white-space: nowrap"
                >
                  Mark as Done
                  <div class="radio"></div>
                </div>
              </div>
              <div class="paragraph">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec a
                diam lectus. Sed sit amet ipsum mauris. Maecenas congue ligula
                ac quam viverra nec
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="width: 40%" class="p-2">
        <table class="countiesTask">
          <thead>
            <tr>
              <th>Student</th>
              <th>Event Date</th>
              <th>Stage Instructor</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>John Doe</td>
              <td>2023-10-01</td>
              <td>Jane Smith</td>
              <td>Completed</td>
            </tr>
            <tr>
              <td>Jane Doe</td>
              <td>2023-10-02</td>
              <td>John Smith</td>
              <td>In Progress</td>
            </tr>
            &lt;!&ndash; Add more rows as needed &ndash;&gt;
          </tbody>
        </table>
      </div>
    </div>-->
    <toast-notifier ref="toast"></toast-notifier>
  </div>
</template>
<script>
import { getProcessedImageUrl } from "@/util/images";
import toastNotifier from "../../../../components/ToastNotifier.vue";
import ClassesAPIService from "../../../../servicehandlers/ClassesAPIService";
const classesAPIService = new ClassesAPIService();
export default {
  name: "AdminClassGradeBook",
  components: {
    toastNotifier,
  },
  data() {
    return {
      isLiabilityOpen: false,
      isClassDocumentsPopUpOpen: false,
      classObj: null,
      students: [],
      assignments: [],
      startDate: null,
      endDate: null,
      grades: null,
    };
  },
  async mounted() {
    await this.getGradesForClass();
  },
  methods: {
    getGradesForClass() {
      if (this.$route.query.classId) {
        return classesAPIService
          .getGradeDetailsForClass(this.$route.query.classId, this.$router)
          .then((response) => {
            this.classObj = response;
            this.classObj.activeInstructor.user.image = getProcessedImageUrl(
              this.classObj.activeInstructor.user.image,
            );
            this.startDate = new Date(this.classObj.startDate);
            this.endDate = new Date(this.classObj.endDate);
            this.$nextTick(() => {
              this.adjustDisplay();
            });
          });
      }
    },
    goToGradedAssignment(assignmentId, studentId) {
      if (assignmentId && studentId) {
        this.$router.push({
          name: "Graded Assignment",
          query: {
            assignmentId,
            studentId,
          },
        });
      } else {
        this.$refs.toast.showInfo("No student submission for assignment");
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    adjustDisplay() {
      const nameCol = document.querySelector("th:first-child");
      const gradeCol = document.querySelector("th:nth-child(2)");
      if (nameCol) {
        document.documentElement.style.setProperty(
          "--name-column-width",
          `${nameCol.offsetWidth}px`,
        );
      }
      if (gradeCol) {
        document.documentElement.style.setProperty(
          "--grade-column-width",
          `${gradeCol.offsetWidth - 1}px`,
        );
      }

      const tableWrapper = document.querySelector(".tableWrapper");
      const fadeOverlayRight = document.querySelector(".fadeRight");
      const fadeOverlayLeft = document.querySelector(".fadeLeft");

      function updateFadeOverlays() {
        const maxScrollLeft =
          tableWrapper.scrollWidth - tableWrapper.clientWidth;
        fadeOverlayRight.style.opacity =
          tableWrapper.scrollLeft >= maxScrollLeft - 1 ? "0" : "1";
        fadeOverlayLeft.style.opacity = tableWrapper.scrollLeft > 0 ? "1" : "0";
      }

      tableWrapper.addEventListener("scroll", () => {
        updateFadeOverlays();
      });

      updateFadeOverlays();
    },
  },
};
</script>
<style scoped>
.notGraded {
  position: relative;
  cursor: pointer;
  color: rgba(0, 0, 0, 50%);
}

.notGraded:hover::after {
  content: "Doesn't Effect Grade";
  position: absolute;
  bottom: 125%;
  left: 50%;
  transform: translateX(-50%);
  background-color: #333;
  color: #fff;
  padding: 5px 8px;
  border-radius: 4px;
  white-space: nowrap;
  z-index: 10;
  opacity: 150%;
  visibility: visible;
}
.notGraded::after {
  content: "";
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s;
}
.text {
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.start121524Parent {
  height: 17px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  font-size: 15px;
}

.textParent {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  z-index: 0;
}

.frameIcon {
  width: 150px;
  border-radius: 22.5px;
  height: 150px;
  overflow: hidden;
  flex-shrink: 0;
  object-fit: cover;
}

.instructorParent {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0px 0px 0px 10px;
  gap: 20px;
}

.instructorName {
  align-self: stretch;
  position: relative;
  font-size: 60px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.frameParent3 {
  align-self: stretch;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}

.frameParent2 {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 50px;
  z-index: 1;
}

.backButtonIcon {
  width: 16px;
  position: relative;
  height: 16px;
  overflow: hidden;
  flex-shrink: 0;
  object-fit: contain;
}

.backButtonWrapper {
  margin: 0 !important;
  position: absolute;
  top: 0px;
  left: -50px;
  background-color: #f6f6f6;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 10px;
  z-index: 2;
  cursor: pointer;
}

.frameParent1 {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0;
  position: relative;
  gap: 20px;
  z-index: 2;
  font-size: 25px;
}

.frameParent {
  height: 100%;
  flex: 1;
  width: 100%;
  position: relative;
  background-color: #f6f6f6;
  overflow-y: auto;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 25px;
  padding: 50px;
  text-align: left;
  font-size: 18px;
  color: #404040;
  font-family: Helvetica, Arial, sans-serif;
}

.tableContainer {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  /* Aligns content to the left */
}

.tableWrapper {
  overflow-x: auto;
  display: block;
  width: auto;
  /* Ensures the table only takes up the necessary width */
  max-width: fit-content;
  /* Prevents it from stretching */
}

table {
  max-width: 100%;
  background-color: white;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 10px;
  border: none !important;
}

.fadeRight {
  position: absolute;
  top: 0;
  right: 0;
  width: 50px;
  height: calc(100% - 15px);
  pointer-events: none;
  background: linear-gradient(
    to left,
    rgba(246, 246, 246, 1),
    rgba(246, 246, 246, 0)
  );
  transition: opacity 0.1s ease-in-out;
  opacity: 0;
}

.fadeLeft {
  position: absolute;
  top: 0;
  left: calc(var(--name-column-width) + var(--grade-column-width));
  width: 50px;
  height: calc(100% - 15px);
  pointer-events: none;
  background: linear-gradient(
    to right,
    rgba(246, 246, 246, 1),
    rgba(246, 246, 246, 0)
  );
  transition: opacity 0.1s ease-in-out;
  opacity: 0;
}

th,
td {
  border: 1px solid #929292;
  padding: 8px;
  text-align: center;
  font-size: 15px;
  font-weight: 400 !important;
}

th {
  background-color: #696969;
  color: white;
  font-weight: bold;
  border-right: #696969 1px solid;
  border-top: none;
  border-bottom: none;
  border-left: none;
}

th.blueHeader {
  background-color: #3c78ff;
  border-right: #3c78ff 2px solid;
  text-align: center;
  position: sticky;
  left: var(--name-column-width);
  /* Dynamically position Grade */
  z-index: 2;
}

th.orangeHeader,
td.orangeHeader {
  background-color: #ff8800;
  border-right: #d97400 1px solid;
  border-left: #d97400 1px solid;
  border-top: none;
  border-bottom: none;
  flex: 1;
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 150px !important;
  max-width: 150px !important;
}

th.orangeHeader:first-child {
  border-left: none;
}

td.blueHeader {
  background-color: #f4f7ff;
  text-align: center;
  position: sticky;
  left: var(--name-column-width);
  /* Dynamically position Grade */
  z-index: 2;
}

td.greyHeader {
  background-color: #e3e3e3;
  border-left: 1px solid #929292;
  white-space: nowrap;
  text-align: left;
  padding: 5px 10px;
}

td {
  font-size: 14px;
  border-top: none;
  border-bottom: 1px solid #929292;
  padding: 5px 7.5px;
  text-align: center;
}

th:first-child {
  border-top-left-radius: 10px;
  border-left: none;
}

th:last-child {
  border-top-right-radius: 10px;
  border-right: none;
}

tbody tr:last-child td:first-child {
  border-bottom-left-radius: 10px;
}

tbody tr:last-child td:last-child {
  border-bottom-right-radius: 10px;
}

th:nth-child(2),
td:nth-child(2) {
}

.gradePercentage {
  cursor: pointer;
}
.gradePercentage:hover {
  text-decoration: underline;
}

th:first-child,
td:first-child {
  position: sticky;
  left: 0;
  z-index: 2;
}

.noClick {
  cursor: not-allowed;
}

.tableBorderWrapper {
  border-radius: 10px;
  overflow: hidden;
  max-width: 100%;
}

.card {
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.card .title {
  font-size: 15px;
  width: 100%;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  padding: 10px;
  color: white;
  text-align: center;
}

.purple-title {
  background-color: #c965ff;
}

.reddish-title {
  background-color: #ff6568;
}

.grey-title {
  background-color: #404040bf;
}

.card .body {
  padding: 10px;
  font-size: 15px;
  height: 450px;
  overflow-y: auto;
  scrollbar-width: none;
}

.card .body::-webkit-scrollbar {
  display: none;
}

.card .glow::after {
  content: "";
  position: absolute;
  border-radius: 10px;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 40px;
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 1)
  );
  pointer-events: none;
}

.radio {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  border: 1px solid #40404080;
  margin-left: 10px;
  margin-top: 1px;
  position: relative;
}

.paragraph {
  font-size: 15px;
  color: #404040;
  margin-top: 10px;
  text-align: justify;
}

.subheader .portion {
  width: 50%;
  max-width: 50%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.greytext {
  color: #40404080;
}

.countiesTask {
  width: 100%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
</style>
